import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "btn btn-icon btn-primary btn-circle btn-sm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      viewName: "lookupDataModel",
      onQueryUpdate: _ctx.syncQuery
    }, {
      "cell-roleCodeText": _withCtx(({ row: role }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(role.roleCodeText), 1)
      ]),
      "cell-createdDate": _withCtx(({ row: role }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.format.Date(role.createdDate)), 1)
      ]),
      "cell-updateDate": _withCtx(({ row: role }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.format.Date(role.updateDate)), 1)
      ]),
      "cell-actions": _withCtx(({ row: role }) => [
        _hoisted_4,
        _createElementVNode("a", {
          onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = role;
          }
        , ["stop"]),
          class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
        }, _hoisted_7, 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "onQueryUpdate"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "lookupsData",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.roleCodeText
    }?`,
      onClose: _ctx.refreshList
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"])
  ], 64))
}